import { Box, Modal } from "@mui/material"
import type { FC } from "react"

interface ModalContainerProps {
  children: React.ReactNode
  isOpen: boolean
  onClose: () => void
}

export const ModalContainer: FC<ModalContainerProps> = ({ children, isOpen, onClose }: ModalContainerProps) => {
  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          boxShadow: 24,
          width: 576,
          borderRadius: 2,
        }}
      >
        {children}
      </Box>
    </Modal>
  )
}
